import { Card, CardHeader, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { FaRegCalendarAlt } from "react-icons/fa";
import LeaveApproveForm from "../../approve";

const LeaveAdminHeader = () => {
  const dialog = useSelector((state) => state.leaveAdmin.approve.dialog);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            ادارة طلبات الاجازة
          </Typography>
        }
        avatar={<FaRegCalendarAlt size={20} />}
      />
      {dialog ? <LeaveApproveForm /> : null}
    </Card>
  );
};

export default LeaveAdminHeader;
